export default __webpack_public_path__ + "static/media/sectionOneImg.b8579ee8.png";